import MmxApi from "../api/mmxApi";

export default {
  updateRegisteredEndpoint: (
    registerExpires,
    contact,
    server,
    securityToken,
    dispatch
  ) => {
    const api = new MmxApi(server, securityToken, dispatch);
    return api.sip.updateRegisteredEndpoint({
      registerExpires: registerExpires,
      contact: encodeURIComponent(contact),
    });
  },
};






// WEBPACK FOOTER //
// ./src/services/sipService.js